<!--
* @Name：供应商付款查看票据
* @Author: 刘玉
* @Date: 2021-12-02 16:13:46
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 16:13:46
-->
<template>
  <div class="component-overlay">
    <van-nav-bar title="查看票据" left-arrow left-text="关闭" @click-left="onClickLeft" :fixed="true" />
    <div class="component-container">
      <hi-card v-for="(item, index) in orderInfo" :key="item.pk" :row-index="index + 1">
        <van-row>
          <span>票据类型：</span>
          <span>{{ item.payMethod | dictFilter(payTermOptions) }}</span>
        </van-row>
        <van-row>
          <span>票据号码：</span>
          <span>{{ item.billCode }}</span>
        </van-row>
        <van-row>
          <span>票据金额：</span>
          <span>{{ item.billAmount }}</span>
        </van-row>
        <van-row>
          <span>票据有效期：</span>
          <span>{{ item.billValidity }}</span>
        </van-row>
        <van-row>
          <span>票据到期日：</span>
          <span>{{ item.billDueDate }}</span>
        </van-row>
      </hi-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewOrder',
  data() {
    return {}
  },
  props: {
    orderInfo: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    payTermOptions() {
      return this.$store.getters.dicts.pay_term
    }
  },
  methods: {
    onClickLeft() {
      this.$emit('close')
    }
  }
}
</script>
